import { useQuery } from "react-query";
import { fetchCampaignsForAnalytics } from "../services/partner/partner.api";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import { useUserPartnerInformation } from "./useUserPartnerInformation";

export function usePartnerCampaignsForAnalytics() {
  const [user] = useAuthState(auth);

  const { userPartnerInformation } = useUserPartnerInformation(user?.uid);

  const partnerId = userPartnerInformation?.data?.partnerId;

  return useQuery(
    ["partnerCampaignsAnalytics", partnerId],
    () => fetchCampaignsForAnalytics(partnerId),
    { enabled: !!partnerId, select: (data) => data.data }
  );
}
